import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'sanitizeHtml',
  standalone: false,
})
export class SanitizeHtmlPipe implements PipeTransform {
  constructor(private readonly _sanitizer: DomSanitizer) {}

  transform(v: string, type: 'html' | 'url'): SafeHtml {
    if (type && type === 'url') {
      return this._sanitizer.bypassSecurityTrustUrl(v as string); //NOSONAR
    } else {
      return this._sanitizer.bypassSecurityTrustHtml(v); //NOSONAR
    }
  }
}
